import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom, noop, Observable, tap } from 'rxjs';
import { environment } from 'projects/shared/environments/environment';
import { MobileToasterService } from 'projects/shared/components/mobile-toaster/services/mobile-toaster.service';
import { BrowserService } from 'projects/shared/services/browser.service';
import { MessageService } from 'primeng/api';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class IpService {
  ip$ = new BehaviorSubject<string>(null!);

  constructor(
    private http: HttpClient,
    private _mobileToaster: MobileToasterService,
    private _browserService: BrowserService,
    private _messageService: MessageService,
    @Inject(PLATFORM_ID) private platformId: Object // ✅ أضف ده
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.setIP();
    }
  }

  setIP() {
    this.getIP().pipe(
      tap(ip => {
        this.ip$.next(ip.ip);
      })
    ).subscribe();
  }

  getIP(): Observable<any> {
    const url = `${environment.apiUrl}utils/get-ip`;
    return this.http.get(url, { withCredentials: true });
  }

}